import { ModulesConfigMap, ModulesMap } from '../data/modulesMaps'

export default {
  getReportsReporting: {
    apiServiceMethodName: ModulesConfigMap[ModulesMap.REPORTS_REPORTING].GET_REPORTS_REPORTING,
  },
  getReportReportingPreview: {
    apiServiceMethodName: ModulesConfigMap[ModulesMap.REPORTS_REPORTING].GET_REPORT_REPORTING_PREVIEW,
  },
  getReportReporting: {
    apiServiceMethodName: ModulesConfigMap[ModulesMap.REPORTS_REPORTING].GET_REPORT_REPORTING,
  }
}